import '@popperjs/core';
import jquery
    from 'jquery';
import aos
    from "aos";

import GLightbox from "glightbox";
import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay} from 'swiper';
import ImagesLoaded from "imagesloaded";
import Isotope from "isotope-layout";

window.jQuery = jquery;
window.$ = jquery;
import {
    Modal
} from 'bootstrap';
import 'lite-youtube-embed';

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    cache: true
});

$.fn.isVisible = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

let utility = {
    viewable: function (e) {
        let docViewTop = $(window).scrollTop();
        let docViewBottom = docViewTop + $(window).height();
        let elemTop = $(e).offset().top;
        let elemBottom = elemTop + $(e).height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    },
    chart: {
        colors:
            [
                'rgb(255, 99, 132)',
                'rgb(54, 162, 235)',
                'rgb(255, 205, 86)'
            ]
        ,
        options: {
            plugins: {
                legend: {
                    labels: {
                        color: '#333333',
                        font: {
                            family: 'DRRegular'
                        }
                    }
                }
            }
        },
        init: function (index) {
            let target = $('.chart').eq(index).attr('id');
            let heading = $('.chart-heading').eq(index).val();
            let type = $('.chart-type').eq(index).val();
            let measurement = $('.chart-measurement').eq(index).val();
            let labelData = JSON.parse($('.chart-labels').eq(index).val());
            let chartData = JSON.parse($('.chart-data').eq(index).val());
            let labels = [];
            let data = [];
            for (let labelDataKey in labelData) {
                labels.push(labelData[labelDataKey]);
            }
            for (let chartDataKey in chartData) {
                data.push(parseInt(chartData[chartDataKey]));
            }
            new Chart(
                document.getElementById(target),
                {
                    type: type,
                    labels: labels,
                    options: utility.chart.options,
                    data: {
                        labels: labels,
                        datasets: [{
                            label: heading,
                            data: data,
                            backgroundColor: utility.chart.colors,
                            hoverOffset: 4
                        }]
                    }
                }
            );
        }
    },
    count: function () {
        let duration = 15;
        let statNumber = $('.stat-number');
        let statCounter = $('.stat-counter');
        statNumber.each(function (i) {
            let max = parseFloat($(this).attr('data-value'));
            let step = Math.round(max / (max < duration ? 10 : duration));
            if (step < 1) {
                step = .07;
            }
            setTimeout(function () {
                let t = setInterval(function () {
                    let current = parseFloat(statCounter.eq(i).val());
                    let number = (step < 1 ? ((current + step).toFixed(2)).toLocaleString() : (current + step).toLocaleString());
                    if (current < max) {

                        statNumber.eq(i).html(number);
                        statCounter.eq(i).val(current + step);
                    }
                    if (current >= max) {
                        clearInterval(t);
                        statNumber.eq(i).html(max.toLocaleString());
                        statCounter.eq(i).val(max);
                    }
                }, 100);
            }, 500);
        });
    },
    image: {
        zoom: function (ElementID) {
            let $Deferred = $.Deferred();
            let $Image = $(ElementID).find('img').clone();
            $Image.removeClass('img-thumbnail');
            let Title = $Image.attr('alt');
            let Options = {
                icon: 'fa fa-image',
                closeable: true,
                title: {
                    text: Title,
                    color: 'text-white'
                },
                state: 'bg-primary',
                size: 'modal-xl'
            };
            $.when(utility.modal.open(Options)).done(function () {
                let $ModalWindowBody = $('#ModalWindowBody');
                $ModalWindowBody.addClass('text-center');
                $('#ModalWindowSaveButton').remove();
                $.when($ModalWindowBody.html($Image)).done(function () {
                    $Deferred.resolve(false);
                });
            });
        }
    },
    scroll: function (e) {
        let Deferred = new $.Deferred();
        $.when($('html').animate({
            scrollTop: (e.offset().top - 100)
        }, "slow")).done(function () {
            Deferred.resolve(true);
        });
        return Deferred.promise();
    },
    modal: {
        content: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: 'fa',
                title: {
                    text: null,
                    color: 'text-white'
                },
                state: 'bg-danger',
                size: 'modal-lg',
                closeable: true
            };
            let url = $(selector).prop('href');
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowSaveButton, #ModalWindowIcon').remove();
                $('#ModalWindowBody').load(url, function (HTML) {
                    $.when($('#ModalWindowBody').html(HTML)).done(function () {
                        let img = '<img src="' + $('#ContentIcon').val() + '" style="height: 32px; width: auto;" alt="img"/>';
                        $('#ModalWindowTitle').html(img);
                        Deferred.resolve(false);
                    });
                }).css({
                    height: '70vh',
                    overflow: 'auto'
                });
                return Deferred.promise();
            });
        },
        defaults: {
            closeable: false,
            icon: 'fa fa-info',
            title: {
                text: 'Info',
                color: 'text-white'
            },
            size: 'modal-lg',
            state: 'bg-info',
            resize: false,
            class: null,
            border: null,
            submitButtonClass: 'btn-success',
            cancelButtonClass: 'btn-secondary'
        },
        loading: function (selector) {
            selector = (selector === undefined ? $('#ModalWindowBody') : selector);
            let HTML = '<div class="text-center" style="width: 100%; margin: auto; padding: 15%;"><i class="fa fa-spinner fa-pulse fa-fw fa-5x text-primary"></i><div style="font-size: 36px;">LOADING...</div></div>';
            selector.html(HTML);
        },
        open: function (options) {
            let Deferred = new $.Deferred();
            if ($('#ModalWindowBody').length === 0) {
                options = {
                    closeable: (options.closeable !== undefined ? options.closeable : utility.modal.defaults.closeable),
                    icon: (options.icon !== undefined ? options.icon : utility.modal.defaults.icon),
                    title: {
                        text: (options.title.text !== undefined ? options.title.text : utility.modal.defaults.title.text),
                        color: (options.title.color !== undefined ? options.title.color : utility.modal.defaults.title.color),
                    },
                    size: (options.size !== undefined ? options.size : utility.modal.defaults.size),
                    state: (options.state !== undefined ? options.state : utility.modal.defaults.state),
                    resize: (options.resize !== undefined ? options.resize : utility.modal.defaults.resize),
                    class: (options.class !== undefined ? options.class : utility.modal.defaults.class),
                    border: (options.border !== undefined ? options.border : utility.modal.defaults.border),
                    submitButtonClass: (options.submitButtonClass !== undefined ? options.submitButtonClass : utility.modal.defaults.submitButtonClass),
                    cancelButtonClass: (options.cancelButtonClass !== undefined ? options.cancelButtonClass : utility.modal.defaults.cancelButtonClass),
                };
                $('#ModalWindowWrapper').load('/actions/modal/modal/open', {}, function () {
                    let $ModalWindowBody = $('#ModalWindowBody');
                    $('#ModalWindowDialog').addClass(options.size);
                    $('#ModalWindowIcon').addClass(options.icon).addClass(options.title.color);
                    $('#ModalWindowTitle').html(options.title.text).addClass(options.title.color);
                    if (options.closeable === false) {
                        $('#ModalWindowCloseButton').hide();
                    }
                    $('#ModalWindowHeader').addClass(options.state);
                    $('#ModalWindowHeader, #ModalWindowBody, #ModalWindowFooter').addClass(options.class);
                    $('#ModalWindowHeader, #ModalWindowFooter').addClass(options.border);
                    $('#ModalWindowSaveButton').addClass(options.submitButtonClass);
                    $('#ModalWindowCancelButton').addClass(options.cancelButtonClass).on('click', function () {
                        $('#ModalWindowCloseButton').trigger('click');
                    });
                    let ModalWindow = document.getElementById('ModalWindow');
                    let $Modal = new Modal(ModalWindow, {
                        backdrop: 'static',
                        keyboard: false
                    });
                    $Modal.show();
                    ModalWindow.addEventListener('hidden.bs.modal', function () {
                        $(this).remove();
                    });
                    if (options.resize === true) {
                        $ModalWindowBody.on('DOMSubtreeModified', function () {
                            utility.modal.resize($(this));
                        });
                    }
                    Deferred.resolve($ModalWindowBody);
                });
            }
            else {
                Deferred.resolve(false);
            }
            return Deferred.promise();
        },
        resize: function ($Element) {
            let ModalHeaderFooterHeight = $('#ModalWindowHeader').outerHeight() + $('#ModalWindowFooter').outerHeight();
            let y = Math.round(($(window).innerHeight() - ModalHeaderFooterHeight) / 1.4);
            $Element.height(y);
            return false;
        },
        scroll: function (selector, offset) {
            let Deferred = new $.Deferred();
            offset = (offset === undefined ? ($('#ModalWindowHeader').height() + 60) : 0);
            $('#ModalWindowBody').animate({
                scrollTop: (selector.offset().top - offset) + $(this).scrollTop()
            }, "slow", function () {
                Deferred.resolve(false);
            });
            return Deferred.promise();
        },
        video: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: 'fa fa-video',
                title: {
                    text: $(selector).attr('data-title'),
                    color: 'text-white'
                },
                state: 'bg-danger',
                size: 'modal-lg'
            };
            $.when(utility.modal.open(options)).done(function () {
                $('#ModalWindowBody').load('/modal/video', function (HTML) {
                    $.when($('#ModalWindowBody').html(HTML)).done(function () {
                        $('#ModalVideoSource').attr('src', $(selector).attr('data-target'));
                        Deferred.resolve(false);
                    });
                });
                $('#ModalWindowSaveButton').remove();
                return Deferred.promise();
            });
        }
    }
}

let dr = {
    recaptcha: {
        load: function () {
            let $Deferred = $.Deferred();
            if ($('#GoogleRecaptcha').length > 0) {
                $.getScript('https://www.google.com/recaptcha/api.js?render=explicit', function () {
                    let t = setInterval(function () {
                        if (typeof grecaptcha.render === 'function') {
                            clearInterval(t);
                            grecaptcha.render('GoogleRecaptcha', {
                                'sitekey': $('#GCKey').val()
                            });
                            $('#GoogleRecaptcha > div').css({
                                margin: 'auto'
                            })
                            $Deferred.resolve(true);
                        }
                    }, 100);
                });
            }
            else {
                $Deferred.resolve(true);
            }
            return $Deferred.promise();
        },
        validate: function () {
            let Response = true;
            if ($('#GoogleRecaptcha').length > 0) {
                let r = grecaptcha.getResponse();
                if (r.length === 0) {
                    Response = false;
                }
            }
            return Response;
        }
    },
    toggle: {
        mobile: function (e) {
            document.querySelector('body').classList.toggle('mobile-nav-active');
            e.classList.toggle('fa-bars');
            e.classList.toggle('fa-xmark');
        },
        menu: function () {
            let scrollTop = document.querySelector('.scroll-top');
            let selectBody = document.querySelector('body');
            let selectHeader = document.querySelector('#header');
            window.scrollY > 100 ? scrollTop.classList.add('active') : scrollTop.classList.remove('active');
            window.scrollY > 100 ? selectHeader.classList.add('shadow') : selectHeader.classList.remove('shadow');
            if (!selectHeader.classList.contains('scroll-up-sticky') && !selectHeader.classList.contains('sticky-top') && !selectHeader.classList.contains('fixed-top')) return;
            window.scrollY > 100 ? selectBody.classList.add('scrolled') : selectBody.classList.remove('scrolled');
        }
    },
    init: function () {
        dr.toggle.menu();
        aos.init({
            once: true,
            disable: function () {
                return /bot|googlebot|insights|inspection|crawler|spider|robot|lighthouse|crawling/i.test(navigator.userAgent);
            }
        });
        $('#preloader').remove();
        $(document).on('load, scroll', function () {
            dr.toggle.menu();
        });
        $('.mobile-nav-toggle').on('click', function () {
            dr.toggle.mobile(this);
        });
        document.querySelectorAll('#navmenu a').forEach(navmenu => {
            navmenu.addEventListener('click', () => {
                if (document.querySelector('.mobile-nav-active')) {
                    mobileNavToogle();
                }
            });

        });
        document.querySelectorAll('.navmenu .toggle-dropdown').forEach(navmenu => {
            navmenu.addEventListener('click', function (e) {
                e.preventDefault();
                this.parentNode.classList.toggle('active');
                this.parentNode.nextElementSibling.classList.toggle('dropdown-active');
                e.stopImmediatePropagation();
            });
        });
        const glightbox = GLightbox({
            selector: '.glightbox'
        });
        const activeElement = document.activeElement;
        if (activeElement) {
            activeElement.blur();
        }
        new Swiper('.init-swiper', {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            speed: 600,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            slidesPerView: "auto",
            pagination: {
                el: '.swiper-pagination',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 40
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 10
                }
            }
        });
        document.querySelectorAll('.isotope-layout').forEach(function (isotopeItem) {
            let layout = isotopeItem.getAttribute('data-layout') ?? 'masonry';
            let filter = isotopeItem.getAttribute('data-default-filter') ?? '*';
            let sort = isotopeItem.getAttribute('data-sort') ?? 'original-order';

            let initIsotope;
            ImagesLoaded(isotopeItem.querySelector('.isotope-container'), function () {
                initIsotope = new Isotope(isotopeItem.querySelector('.isotope-container'), {
                    itemSelector: '.isotope-item',
                    layoutMode: layout,
                    filter: filter,
                    sortBy: sort
                });
            });

            isotopeItem.querySelectorAll('.isotope-filters li').forEach(function (filters) {
                filters.addEventListener('click', function () {
                    isotopeItem.querySelector('.isotope-filters .filter-active').classList.remove('filter-active');
                    this.classList.add('filter-active');
                    initIsotope.arrange({
                        filter: this.getAttribute('data-filter')
                    });
                }, false);
            });
        });
        if ($('#QuoteForm').length > 0) {
            dr.contact.init();
        }

        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MH4PKK43');

        document.addEventListener('click', function(event) {
            const link = event.target.closest('a');
            if (link && link.href.startsWith('tel:')) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'phone_call',
                    'event_category': window.location.title,
                    'event_label': window.location.pathname
                });
            }
        });
    },
    contact: {
        init: function () {
            $.when(dr.recaptcha.load()).done(function () {
                dr.form.init('QuoteForm');
            });
        }
    },
    form: {
        init: function (FormID) {
            document.addEventListener('click', function(event) {
                const link = event.target.closest('a');
                if (link && link.hash && link.getAttribute('href').startsWith('#')) {
                    event.preventDefault();
                    const targetElement = document.getElementById('FirstName');
                    targetElement.focus();
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
            let form = document.getElementById(FormID);
            let filterCurrent = [];
            document.querySelectorAll('.quote-option').forEach(field => {
                field.style.display = 'none';
            });
            document.querySelectorAll('.quote-option-parent').forEach(field => {
                field.addEventListener('change', function () {
                    document.querySelectorAll('.quote-option').forEach(field => {
                        field.style.display = 'none';
                    });
                    if (this.checked) {
                        filterCurrent = this.getAttribute('data-filter').split(', ');
                    }
                    document.querySelectorAll('.quote-option').forEach(option => {
                        let filterField = option.getAttribute('data-filter').split(', ');
                        let input = option.querySelector('.form-check-input');
                        filterField.forEach((f) => {
                            if (filterCurrent.includes(f)) {
                                option.style.display = 'flex';
                            }
                        });
                        if (input !== null) {
                            let filterInput = input.getAttribute('data-filter').split(', ');
                            filterInput.forEach((f) => {
                                if (filterCurrent.includes(f)) {
                                    input.style.display = 'inline-block';
                                    input.setAttribute('required', 'required');
                                }
                                else {
                                    input.removeAttribute('required');
                                }
                            });
                        }
                    });
                });
            });
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                let $GoogleRecaptcha = $('#GoogleRecaptcha');
                let grv = true;
                if ($GoogleRecaptcha.length > 0) {
                    let grv = dr.recaptcha.validate();
                }
                if (form.checkValidity() === false || grv === false) {
                    event.stopPropagation();
                    if (grv === false) {
                        $GoogleRecaptcha.addClass('border border-danger');
                        utility.scroll($GoogleRecaptcha);
                    }
                    utility.scroll($('.form-control:invalid, .form-check-input:invalid, .form-select:invalid').eq(0));
                }
                else {
                    dr.form.submit(FormID);
                }
                if (grv === true && $GoogleRecaptcha.length > 0) {
                    $GoogleRecaptcha.removeClass('border border-danger');
                }
                form.classList.add('was-validated');
            }, false);
        },
        conversion: function (Response) {
            if (Response.Data.SendMail.ErrorCode === 0) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'generate_lead',
                    formId: 'lead-gen',
                    formType: "Contact",
                    submittedAt: new Date().toISOString()
                });
            }
            return false;
        },
        submit: function (FormID) {
            let Deferred = new $.Deferred();
            let $FormID = $('#' + FormID);
            let buttonText = $('.btn-submit').html();
            $('.btn-submit').attr('disabled', 'disabled').html('<i class="fa fa-spinner fa-spin"></i>');
            $.ajax('', {
                type: 'POST',
                dataType: 'JSON',
                data: $FormID.serialize()
            }).done(function (Response) {
                $('.btn-submit').removeAttr('disabled').html('Done!');
                let Options = {
                    icon: 'fa fa-info-circle',
                    title: {
                        text: (Response.Data.SendMail.ErrorCode === 0 ? 'Request Received' : 'Error'),
                        color: 'text-white'
                    },
                    state: 'bg-' + (Response.Data.SendMail.ErrorCode === 0  ? 'success' : 'danger'),
                    size: 'modal-lg'
                };
                $.when(utility.modal.open(Options)).done(function () {
                    dr.form.conversion(Response);
                    $('#ModalWindowSaveButton').remove();
                    $.when($('#ModalWindowBody').html(Response.HTML)).done(function () {
                        $('#ModalWindowCancelButton').on('click', function () {
                            window.location = '/';
                        });
                        Deferred.resolve(false);
                    });
                });

            });
            return Deferred.promise();
        }
    }
}
$(function () {
    dr.init();
});